export default "__VITE_ASSET__792ae9a5__"